import { call, fork } from 'redux-saga/effects';

import { webSockets } from 'app/packages/lib';

import mainHubInstance, { type SubscriptionsExtArgs } from '../../hub/main-hub';
import { subscribeToHub, type SubscribeToSignalrProps } from './subscribe-to-hub';

// ---

type BaseSubscriptionsSagaProps = Pick<
  SubscribeToSignalrProps, 'subscribeAction' | 'unsubscribeAction'
>;

// ---

function createSubscriptionSaga(
  hub: webSockets.BaseHub,
  props: BaseSubscriptionsSagaProps,
  onSubscribe: SubscribeToSignalrProps['onSubscribe'],
) {
  function* onUnsubscribe(topic: string) {
    yield call([hub, hub.unsubscribe], topic);
  }

  const propsToSignalr: SubscribeToSignalrProps = {
    ...props,
    onSubscribe,
    onUnsubscribe,
    emmiter: mainHubInstance.emmiter,
  };

  return fork(subscribeToHub, propsToSignalr);
}

// ---

export function* subscriptionsSaga(props: BaseSubscriptionsSagaProps) {
  const hub = mainHubInstance.tryToGetHubConnection('subscribe');

  function* onSubscribe(topic: string) {
    yield call([hub, hub.subscribe], topic);
  }

  yield createSubscriptionSaga(hub, props, onSubscribe);
}

// ---

type SubscriptionsExtProps = BaseSubscriptionsSagaProps & {
  args: Omit<SubscriptionsExtArgs, 'Type'>;
  type: SubscriptionsExtArgs['Type'];
  matchGroupName?: string;
  onlyCustomStakeNames?: boolean;
};

export function* subscriptionsExtSaga(props: SubscriptionsExtProps) {
  const hub = mainHubInstance.tryToGetHubConnection('subscribeExt');

  function* onSubscribe(topic: string, args: SubscriptionsExtProps['args']) {
    yield call(
      [hub, hub.subscribe],
      topic,
      {
        ...args,
        Type: props.type,
        matchGroupName: props.matchGroupName,
        onlyCustomStakeNames: props.onlyCustomStakeNames,
      },
    );
  }

  yield createSubscriptionSaga(hub, props, onSubscribe);
}


export function* subscriptionsFavoritesSaga(props: BaseSubscriptionsSagaProps) {
  const hub = mainHubInstance.tryToGetHubConnection('subscribeFavorites');

  function* onSubscribe() {
    yield call([hub, hub.subscribe]);
  }

  yield createSubscriptionSaga(hub, props, onSubscribe);
}
